import { render } from "./PlayoutHeader.vue?vue&type=template&id=08ae5db0"
import script from "./PlayoutHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutHeader.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayout/PlayoutHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08ae5db0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08ae5db0', __exports__)) {
    api.reload('08ae5db0', __exports__)
  }
  
  module.hot.accept("./PlayoutHeader.vue?vue&type=template&id=08ae5db0", () => {
    api.rerender('08ae5db0', render)
  })

}


export default __exports__